import React, { useCallback, useState, useEffect } from 'react';
import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import firebase from './constants/firebase';
import {db} from './constants/firebase';
import theme from './Themer';
import { ThemeProvider } from '@material-ui/core/styles';
import Divider from '@material-ui/core/Divider';
import Box from '@material-ui/core/Box';

const useStyles = makeStyles((theme) => ({
  paper: {
    marginTop: theme.spacing(8),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  submit: props => ({
    margin: theme.spacing(3, 0, 2),
    background: props.palette.gradient.default
  }),
}));

export default function ApplicationFee(props) {
  const currentTheme = theme();
  const classes = useStyles(currentTheme);
  const { history } = props;
  const [link, setLink] = useState(props.props.link ? props.props.link : "");
  const handleNext = props.props ? props.props.function: "";

  const handleSignUp = useCallback(
    async event => {
      event.preventDefault();
      const {link} = event.target.elements;
      try {
       
        var user = firebase.auth().currentUser;
        const dateObj = new Date();
        const options = {year: 'numeric', month: 'long', day: 'numeric'};
        const date = dateObj.toLocaleDateString(undefined, options)
        const time = dateObj.toLocaleTimeString(undefined, { hour: '2-digit', minute: '2-digit' });

        db.collection("users").doc(user.email).update({
          ApplicationFee: {
            link: link.value,
            completed: true
          },
          LastUpdated: (date + " " + time)
        });

        console.log(link.value);
        handleNext();
      } catch (error) {
        alert(error);
      }
    },
    [history]
  );

   const onChangeFunction = (component, value) => {
        setLink(value);
    };

   const populateValues = () => {
        console.log("in here")
        const fs = firebase.firestore()
        var user = firebase.auth().currentUser;
        fs.collection("users").doc(user.email).get()
        .then((snapshot) => {
            if (snapshot.exists) { 
            const dat  = snapshot.data()
            setLink(dat.ApplicationFee.link ? dat.ApplicationFee.link : "")
            } else {
            console.log("No data available");
            }
        }).catch((error) => {
            console.log("error")
        })
   }

  return (
    <ThemeProvider theme={currentTheme}>
    <Container component="main" maxWidth="sm">
      <CssBaseline />
      <div className={classes.paper}>
      <Typography component="h1" variant="h3">
            Application Fee
        </Typography>
        <Box marginBottom={2}>
        <Divider variant="middle" />
        </Box>
        <Typography component="h1" variant="body1">
        Payments should be made via Eventbrite, The fee is $120 for the Regular deadline. This fee will not be refunded under any circumstances. 
        </Typography>
        <Button
            fullWidth
            variant="contained"
            className={classes.submit}
            onClick={()=> window.open("https://bit.ly/3z7AD4f", "_blank")}>
          
            Go to Link
          </Button>
        <Box pb={2}/>
        <Typography component="h1" variant="body1">
        (Note: If your team is accepted to compete in Bhangra in the Burgh XV, you will additionally be required to submit a post-registration fee of $45 per member to be on the roster. This is only if your team is accepted, and will be requested of you in a post-acceptance packet). 
        </Typography>
        <Box pb={2}/>
        <Typography component="h1" variant="body1">
        Please submit a public viewable link to a screenshot of the payment confirmation. If the link is not viewable, we will email you ASAP and require that you send us an updated link. If the link is not sent within our time frame, you will be subject to a fine for consideration of your application. 
        </Typography>
        <Box pb={2}/>
        <form className={classes.form} onSubmit={handleSignUp}>
          <TextField
            variant="outlined"
            margin="normal"
            required
            fullWidth
            id="link"
            label="Link"
            name="link"
            value = {link}
            onChange = {onChangeFunction}
            autoFocus
          />
          <Button
            type="submit"
            fullWidth
            variant="contained"
            className={classes.submit}
          >
            Submit
          </Button>
        </form>
        {/* <Button
            type="submit"
            fullWidth
            variant="contained"
            className={classes.submit}
            onClick={populateValues}
          >
            Not seeing anything? Retrieve Submitted Information
          </Button> */}
      </div>
    </Container>
    </ThemeProvider>
  );
}